//$FlowFixMe
import duel1 from './1.webp'
//$FlowFixMe
import duel2 from './2.webp'
//$FlowFixMe
import duel3 from './3.webp'
//$FlowFixMe
import duel4 from './4.webp'
//$FlowFixMe
import duel5 from './5.webp'
//$FlowFixMe
import duel6 from './6.webp'
//$FlowFixMe
import duel7 from './7.webp'
//$FlowFixMe
import duel8 from './8.webp'
//$FlowFixMe
import duel9 from './9.webp'
//$FlowFixMe
import duel10 from './10.webp'
//$FlowFixMe
import duel11 from './11.webp'
//$FlowFixMe
import duel12 from './12.webp'
//$FlowFixMe
import duel13 from './13.webp'
//$FlowFixMe
import duel14 from './14.webp'
//$FlowFixMe
import more from './more.webp'

export const assets = [
    duel1,
    duel2,
    duel3,
    duel4,
    duel5,
    duel6,
    duel7,
    duel8,
    duel9,
    duel10,
    duel11,
    duel12,
    duel13,
    duel14,
    more
]
